module.exports = __webpack_public_path__ + "img/team-emptry.dcab16de.png";